import { gql, useMutation } from '@apollo/client'
import { storage, Toast } from '../utils/index'
import { setCheckout } from './client'

const CheckoutFragment = gql`
    fragment CheckoutFragment on Checkout {
        id
        webUrl
        totalTax
        subtotalPrice
        totalPrice
        lineItems(first: 250) {
            edges {
                node {
                    id
                    title
                    variant {
                        id
                        title
                        image {
                            src
                        }
                        price
                    }
                    quantity
                }
            }
        }
    }
`

// 创建checkout
export const CREATE_CHECKOUT = gql`
    mutation checkoutCreate($input: CheckoutCreateInput!) {
        checkoutCreate(input: $input) {
            userErrors {
                message
                field
            }
            checkout {
                ...CheckoutFragment
            }
        }
    }
    ${CheckoutFragment}
`

// 将当前用户与checkout绑定
export const CHECKOUT_CUSTOMER_ASSOCIATE = gql`
    mutation checkoutCustomerAssociate($checkoutId: ID!, $customerAccessToken: String!) {
        checkoutCustomerAssociate(
            checkoutId: $checkoutId
            customerAccessToken: $customerAccessToken
        ) {
            userErrors {
                field
                message
            }
            checkout {
                ...CheckoutFragment
            }
        }
    }
    ${CheckoutFragment}
`

// 添加购物车
export const CHECKOUT_LINE_ITEMS_ADD = gql`
    mutation checkoutLineItemsAdd($checkoutId: ID!, $lineItems: [CheckoutLineItemInput!]!) {
        checkoutLineItemsAdd(checkoutId: $checkoutId, lineItems: $lineItems) {
            userErrors {
                message
                field
            }
            checkout {
                ...CheckoutFragment
            }
        }
    }
    ${CheckoutFragment}
`

// 更新购物车
export const CHECKOUT_LINE_ITEMS_UPDATE = gql`
    mutation checkoutLineItemsUpdate(
        $checkoutId: ID!
        $lineItems: [CheckoutLineItemUpdateInput!]!
    ) {
        checkoutLineItemsUpdate(checkoutId: $checkoutId, lineItems: $lineItems) {
            userErrors {
                message
                field
            }
            checkout {
                ...CheckoutFragment
            }
        }
    }
    ${CheckoutFragment}
`

// 注册用户
export const CUSTOMER_CREATE = gql`
    mutation customerCreate($input: CustomerCreateInput!) {
        customerCreate(input: $input) {
            userErrors {
                field
                message
            }
            customer {
                id
            }
        }
    }
`

// 登录，获取token
export const CUSTOMER_ACCESS_TOKEN_CREATE = gql`
    mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
        customerAccessTokenCreate(input: $input) {
            userErrors {
                field
                message
            }
            customerAccessToken {
                accessToken
                expiresAt
            }
        }
    }
`

// 重置密码
export const CUSTOMER_RECOVER = gql`
    mutation customerRecover($email: String!) {
        customerRecover(email: $email) {
            customerUserErrors {
                code
                field
                message
            }
        }
    }
`

export const CUSTOMER_ADDRESS_UPDATE = gql`
    mutation customerAddressUpdate(
        $customerAccessToken: String!
        $id: ID!
        $address: MailingAddressInput!
    ) {
        customerAddressUpdate(
            customerAccessToken: $customerAccessToken
            id: $id
            address: $address
        ) {
            customerAddress {
                id
            }
            customerUserErrors {
                code
                field
                message
            }
        }
    }
`

export const CUSTOMER_ADDRESS_CREATE = gql`
    mutation customerAddressCreate($customerAccessToken: String!, $address: MailingAddressInput!) {
        customerAddressCreate(customerAccessToken: $customerAccessToken, address: $address) {
            customerAddress {
                id
            }
            customerUserErrors {
                code
                field
                message
            }
        }
    }
`

// action

export const useCheckoutLineItemsAdd = () => {
    const [mutate, { loading }] = useMutation(CHECKOUT_LINE_ITEMS_ADD, {
        update(cache, { data }) {
            setCheckout(data.checkoutLineItemsAdd.checkout)
            Toast('Success!')
        },
    })
    return [mutate, loading]
}

export const useCheckoutLineItemsUpdate = () => {
    const [mutate, { loading }] = useMutation(CHECKOUT_LINE_ITEMS_UPDATE, {
        update(cache, { data }) {
            setCheckout(data.checkoutLineItemsUpdate.checkout)
            Toast('Success!')
        },
    })
    return [mutate, loading]
}

export const useCustomerCreate = () => {
    const [mutate, { data, loading }] = useMutation(CUSTOMER_CREATE, {
        update(cache) {},
        onCompleted({ customerCreate }) {
            if (customerCreate?.customer) {
                Toast('success')
            } else {
                Toast('注册失败')
            }
        },
    })
    return [mutate, data, loading]
}

export const useCustomerRecover = () => {
    const [mutate, { data, loading }] = useMutation(CUSTOMER_RECOVER, {
        update(cache, { data }) {
            const error = data?.customerRecover?.customerUserErrors[0]
            if (error) {
                Toast(error.message)
                return
            }
            Toast('重置密码链接已发送至您的邮箱!')
        },
    })
    return [mutate, data, loading]
}

export const useCustomerLogin = (history) => {
    const [associate] = useMutation(CHECKOUT_CUSTOMER_ASSOCIATE)
    const [mutate, { data, loading }] = useMutation(CUSTOMER_ACCESS_TOKEN_CREATE, {
        update(cache, { data }) {
            const checkout = storage.getItem('checkout')
            const { accessToken } = data.customerAccessTokenCreate.customerAccessToken
            storage.setItem('accessToken', accessToken)
            associate({
                variables: {
                    checkoutId: checkout.id,
                    customerAccessToken: accessToken,
                },
            })
            history.push('/')
        },
    })
    return [mutate, data, loading]
}
